import portfolioManifest from '../../../content/space/portfolio.json';
import { PortfolioItem, portfolioItemSchema } from '@/lib/content';
import PageMeta from '@/shared/components/PageMeta';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { getText } from '@/shared/utils/i18n';
// 逐条校验：单个条目写错只丢那一条并报错，不让整面照片墙静默变空
const items: PortfolioItem[] = (Array.isArray(portfolioManifest) ? portfolioManifest : []).flatMap(
  entry => {
    const result = portfolioItemSchema.safeParse(entry);
    if (!result.success) {
      console.error('[portfolio] 条目校验失败，已跳过:', entry, result.error.issues);
      return [];
    }
    return [result.data];
  }
);

export default function PortfolioPage() {
  const { t } = useLanguage();

  return (
    <div className="pt-24 px-6">
      <PageMeta title="Portfolio" description={getText('portfolioTagline', 'en')} path="/space/portfolio" />
      <div className="max-w-5xl mx-auto space-y-12">
        <header>
          <h1 className="text-4xl font-bold mb-3">{t('spacePortfolio')}</h1>
          <p className="text-lg text-muted-foreground">{t('portfolioTagline')}</p>
        </header>

        {/* CSS columns 瀑布流 */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
          {items.map(item => (
            <figure
              key={item.src}
              className="group relative break-inside-avoid mb-4 overflow-hidden rounded-xl bg-muted/30"
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="w-full h-auto transition-transform duration-500 group-hover:scale-[1.02]"
              />
              {(item.caption || item.date) && (
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent px-4 pb-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity">
                  {item.caption && <p className="text-sm text-white">{item.caption}</p>}
                  {item.date && <p className="text-xs text-white/70">{item.date}</p>}
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}
